module.exports = __webpack_public_path__ + "static/media/1.181f9d5c.jpg";